//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import ReconnectingWebSocket from "reconnecting-websocket";

class _socketService {
  constructor() {
    this.socket = null;
    this.url = null;
    this.socket_id = null;
    this.handlers = {};
  }

  setHandler(channel, fun) {
    this.handlers[channel] = fun;
  }

  async connect(url, clientId, profileName) {
    if (url) {
      const auth_data = {
        "GlassesOn-Client-Id": clientId,
        "GlassesOn-Profile-Name": profileName,
        domain: window.location.hostname,
      };
      const params = btoa(JSON.stringify(auth_data));
      this.url = url + "?data=" + params;
    }

    this.socket = new ReconnectingWebSocket(this.url, [], {
      maxRetries: 10, // (Number) number of reconnection attempts before giving up (Infinity),
      minReconnectionDelay: 500, // (Number) how long to initially wait before attempting a new (1000)
    });

    this.socket.addEventListener("message", (event) => {
      let data = JSON.parse(event.data);
      let func = this.handlers[data.channel];
      func(data);
    });

    this.socket.addEventListener("close", async function () {
      console.log("disconnect");
    });
    return this.socket;
  }
}

const SocketService = new _socketService();
export default SocketService;
